import { toast } from "react-toastify";
import { Loader } from "../Component/loader";
import { useState } from "react";
import ForgetPasswordFunc from "../../services/forgetPassword";

const DeleteAccountConfirm = () => {
  const { confirmDeleteAccount } = ForgetPasswordFunc();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [load, setLoad] = useState(false);

  const emailSubmit = (e) => {
    e.preventDefault();
    if (!email || !pass) {
      toast.error("Please enter your email and password");
      return;
    }
    setLoad(true);
    const resetEmail = { email: email, password: pass };

    confirmDeleteAccount(resetEmail)
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((res) => {
        console.error(res);
        toast.error(res);
      })
      .finally(() => setLoad(false));
  };

  return (
    <div className="login">
      <div className="card">
        {load ? (
          <Loader />
        ) : (
          <div className="card-body">
            <div className="loginOuter">
              <div className="loginHeader">Type Your Email Address</div>
              <form className="loginBody" id="my-form1" onSubmit={emailSubmit}>
                <div className="fields">
                  <label htmlFor="emailLogin">Email</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="fields">
                  <label htmlFor="emailPass">Password</label>
                  <input
                    type="password"
                    required
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                  />
                </div>
                <div className="fields">
                  <button type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteAccountConfirm;
